import { Link } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";

const input = "mt-1 w-full rounded-xl border border-black/10 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#FF5A00]";

function Field({ label, testId, value, onChange, placeholder, inputMode }) {
  return (
    <label className="block text-sm font-medium">{label}
      <input required data-testid={testId} inputMode={inputMode} placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} className={input} />
    </label>
  );
}

function Notices({ kycStatus, kycOk, payCfg, error }) {
  return (
    <>
      {kycStatus && !kycOk && <p className="rounded-xl bg-amber-50 p-3 text-sm text-amber-800" data-testid="checkout-kyc-required">Submit your licence, Aadhaar and live selfie above to continue.</p>}
      {payCfg && !payCfg.enabled && <p className="rounded-xl bg-amber-50 p-3 text-sm text-amber-800" data-testid="checkout-payments-off">Online payments are temporarily unavailable. Please check back shortly or contact support.</p>}
      {error && <p className="rounded-xl bg-rose-50 p-3 text-sm text-rose-700" data-testid="checkout-error">{error}</p>}
    </>
  );
}

const legalLink = (to, text) => <Link to={to} target="_blank" className="text-[#FF5A00] underline">{text}</Link>;

export function DriverForm({ car, form, setForm, agree, setAgree, onSubmit, busy, canPay, quote, notices, phoneSlot, couponSlot }) {
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  return (
    <form onSubmit={onSubmit} className="space-y-6 rounded-3xl border border-black/5 bg-white p-6 sm:p-8" data-testid="checkout-form">
      <h2 className="text-xl font-semibold">Driver details</h2>
      <Field label="Full name (as on driving licence)" testId="checkout-name" value={form.name} onChange={set("name")} />
      <Field label="Mobile number" testId="checkout-phone" inputMode="numeric" placeholder="10-digit mobile number" value={form.phone} onChange={set("phone")} />
      {phoneSlot}
      <Field label="Pickup location / delivery address" testId="checkout-location" placeholder={`e.g. ${car.city} hub or your address`} value={form.location} onChange={set("location")} />
      <div className="rounded-2xl bg-neutral-50 p-4 text-sm text-neutral-600">
        Please carry your original driving licence and a government photo ID (Aadhaar / Passport) at pickup. The driver must be at least 21 years old.
      </div>
      {couponSlot}
      <label className="flex items-start gap-3 text-sm">
        <Checkbox checked={agree} onCheckedChange={(v) => setAgree(!!v)} data-testid="checkout-agree" className="mt-0.5" />
        <span>I have read and agree to the {legalLink("/legal/terms", "Terms of Use")}, {legalLink("/legal/rental-agreement", "Rental Agreement")}, {legalLink("/legal/payments-refunds", "Payments, Deposit & Refund Policy")} and {legalLink("/legal/privacy", "Privacy Policy")}.</span>
      </label>
      <Notices {...notices} />
      <button type="submit" disabled={busy || !agree || !canPay} data-testid="checkout-pay-btn"
        className="flex w-full items-center justify-center gap-2 rounded-full bg-[#FF5A00] py-4 font-semibold text-white transition-[background-color,transform] duration-200 hover:bg-[#e65100] active:scale-[.98] disabled:cursor-not-allowed disabled:bg-neutral-300">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-4 w-4" />}
        {busy ? "Opening secure checkout…" : quote ? `Pay ₹${quote.total.toLocaleString("en-IN")} securely` : "Pay securely"}
      </button>
      <p className="text-center text-xs text-neutral-500">Payments are processed securely by Cashfree. UPI, cards and netbanking accepted.</p>
    </form>
  );
}
